// Free shipping eligibility status

let fsText, fsNote, fsBtn, elCheBtns;

const defineShEliBarEls = function () {
  fsText = document.querySelector('.pn-cart-fs-text');
  fsNote = document.querySelector('.pn-cart-fs-note');
  fsBtn = document.querySelector('.pn-cart-fs-btn');
  elCheBtns = document.querySelectorAll('#search_postcode');
};

defineShEliBarEls();

const fsThreshold = 79;

const getCartTotal = function () {
  const orderTotalEl = document.querySelector('.cart__total-value');

  if (!orderTotalEl) return 0;

  return parseFloat(
    orderTotalEl.innerText.replace(/[^0-9.-]/g, '')
  ) || 0;
};


const updateCheckoutButtonState = function () {
  const checkoutBtns = document.querySelectorAll('.pn-checkout-btn');

  const eligibility = localStorage.getItem('post_code_eligible');
  const postcode = localStorage.getItem('post_code_checked');

  const hasCheckedPostcode =
    postcode &&
    (eligibility === 'true' || eligibility === 'false');

  checkoutBtns.forEach(function (checkoutBtn) {
    const checkoutLabel = checkoutBtn.querySelector('.pn-checkout-label');

    if (!checkoutLabel) return;

    if (hasCheckedPostcode) {
      checkoutLabel.innerText = 'Secure Checkout';
      checkoutBtn.dataset.postcodeChecked = 'true';
    } else {
      checkoutLabel.innerText = 'Check Postcode & Continue';
      checkoutBtn.dataset.postcodeChecked = 'false';
    }
  });
};



const renderShippingStatus = function () {
  const shippingBlocks = document.querySelectorAll('.pn-cart-fs');

  updateCheckoutButtonState();

  if (!shippingBlocks.length) return;

  const eligibility = localStorage.getItem('post_code_eligible');
  const postcode = localStorage.getItem('post_code_checked');
  const cartTotal = getCartTotal();

  shippingBlocks.forEach(function (shippingBlock) {
    const text = shippingBlock.querySelector('.pn-cart-fs-text');
    const note = shippingBlock.querySelector('.pn-cart-fs-note');
    const btn = shippingBlock.querySelector('.pn-cart-fs-btn');

    if (!text || !note || !btn) return;

    if (!eligibility || !postcode) {
      text.innerHTML =
        '<b>Check your postcode for free shipping eligibility.</b>';

      note.innerHTML = '';
      btn.innerText = 'Check your eligibility.';
      return;
    }

    if (eligibility === 'true') {
      text.innerHTML =
        `Postcode <b>${postcode}</b> is eligible for <b>FREE Shipping</b>.`;

      if (cartTotal < fsThreshold) {
        const difference = (fsThreshold - cartTotal).toFixed(2);

        note.innerHTML =
          `Add <b>$${difference}</b> more to get <b>FREE Shipping</b>.`;
      } else {
        note.innerHTML = '';
      }

      btn.innerText = 'Check another postcode.';
      return;
    }

    if (eligibility === 'false') {
      text.innerHTML =
        `Postcode <b>${postcode}</b> is NOT eligible for free shipping.`;

      note.innerHTML =
        'A delivery fee will be calculated at checkout.';

      btn.innerText = 'Check another postcode.';
    }
  });
};



const saveEligibilityResult = function () {
  const postcodeInput = document.querySelector('#input_postcode');
  const postcode = postcodeInput?.value.trim();

  if (postcode) {
    localStorage.setItem('post_code_checked', postcode);

    // New postcode requires a fresh eligibility result.
    localStorage.removeItem('post_code_eligible');

    renderShippingStatus();
  }

  const checkEligibilityResult = function (attempt = 0) {
    // Stop an older check from overwriting a newer postcode.
    if (localStorage.getItem('post_code_checked') !== postcode) return;

    const shippingRates = document.querySelector('#shipping_rates');
    const shippingError = document.querySelector('.ShippingEstimator__Error');

    if (
      shippingRates &&
      shippingRates.innerText.includes(
        'Your postcode is eligible for FREE shipping'
      ) &&
      window.getComputedStyle(shippingRates).display !== 'none'
    ) {
      localStorage.setItem('post_code_eligible', 'true');
      renderShippingStatus();

      if (popOl && popOl.classList.contains('by-cart')) {
        const continueBtn = document.querySelector('.pn-popup-continue');

        if (continueBtn) {
          continueBtn.style.display = 'block';
        }
      }

      return;
    }

    if (
      shippingError &&
      shippingError.innerText.includes(
        'Free shipping is NOT available for this postcode'
      ) &&
      window.getComputedStyle(shippingError).display !== 'none'
    ) {
      localStorage.setItem('post_code_eligible', 'false');
      renderShippingStatus();

      if (popOl && popOl.classList.contains('by-cart')) {
        const continueBtn = document.querySelector('.pn-popup-continue');

        if (continueBtn) {
          continueBtn.style.display = 'block';
        }
      }

      return;
    }

    if (attempt < 19) {
      setTimeout(function () {
        checkEligibilityResult(attempt + 1);
      }, 500);
    }
  };

  setTimeout(function () {
    checkEligibilityResult();
  }, 500);
};

const bindEligibilityButtons = function () {
  elCheBtns.forEach(function (elCheBtn) {
    elCheBtn.addEventListener('click', saveEligibilityResult);
  });
};

bindEligibilityButtons();
renderShippingStatus();

const orderTotalEl = document.querySelector('.cart__total-value');

if (orderTotalEl) {
  const observer = new MutationObserver(function () {
    renderShippingStatus();
  });

  observer.observe(orderTotalEl, {
    childList: true,
    characterData: true,
    subtree: true
  });
}


// Re-open cart drawer after eligibility popup

const popOl = document.querySelector('.popup-overlay');
const chElPopup = document.getElementById('check-eligibility-popup');

const openCartManually = function () {
  const cartDrawer = document.querySelector('cart-drawer-component');
  const dialog = cartDrawer?.querySelector('dialog');

  if (dialog && !dialog.open) {
    dialog.showModal();
  }
};

const markElPop = function () {
  if (popOl) {
    popOl.classList.add('by-cart');
  }
};

if (fsBtn) {
  fsBtn.addEventListener('click', markElPop);
}

// Require postcode check before checkout
document.addEventListener(
  'click',
  function (e) {
    const checkoutBtn = e.target.closest('.pn-checkout-btn');

    if (!checkoutBtn) return;

    const eligibility = localStorage.getItem('post_code_eligible');
    const postcode = localStorage.getItem('post_code_checked');

    const hasCheckedPostcode =
      postcode &&
      (eligibility === 'true' || eligibility === 'false');

    // Completed YES or NO result can proceed normally.
    if (hasCheckedPostcode) return;

    // Stop Shopify checkout.
    e.preventDefault();
    e.stopImmediatePropagation();

    const context = checkoutBtn.dataset.shippingContext;

    const eligibilityBtn = document.querySelector(
      `.pn-cart-fs[data-shipping-context="${context}"] .pn-cart-fs-btn`
    );

    // Only drawer-originated popup should reopen the drawer on close.
    if (context === 'drawer' && popOl) {
      popOl.classList.add('by-cart');
    }

    if (eligibilityBtn) {
      eligibilityBtn.click();
    }
  },
  true
);

document.addEventListener(
  'click',
  function (e) {
    if (!popOl || !popOl.classList.contains('by-cart')) return;

    const popup = document.getElementById('check-eligibility-popup');
    if (!popup) return;

    const content = popup.querySelector('.popup-content');

    if (
      popup.contains(e.target) &&
      content &&
      !content.contains(e.target)
    ) {
      openCartManually();
    }

    if (e.target.classList.contains('popup-close')) {
      openCartManually();
    }
  },
  true
);

const cartDr = document.querySelector('.cart-drawer__dialog');

if (cartDr && popOl && chElPopup) {
  const cartObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'open'
      ) {
        if (
          !cartDr.hasAttribute('open') &&
          popOl.classList.contains('by-cart') &&
          window.getComputedStyle(chElPopup).display === 'none'
        ) {
          popOl.classList.remove('by-cart');
        }
      }
    });
  });

  cartObserver.observe(cartDr, {
    attributes: true,
    attributeFilter: ['open']
  });
}

setTimeout(function () {
  const atcBtn = document.querySelector('.add-to-cart-button');

  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      setTimeout(function () {
        defineShEliBarEls();
        bindEligibilityButtons();
        renderShippingStatus();

        if (fsBtn) {
          fsBtn.addEventListener('click', markElPop);
        }
      }, 3000);
    });
  }
}, 2000);